import React from 'react';

const Services: React.FC = () => {
  return (
    <section id="services" className="py-24 bg-simios-dark relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-extrabold text-white sm:text-4xl">
            Advisory & Consultancy
          </h2>
          <p className="mt-4 max-w-2xl mx-auto text-xl text-simios-muted">
            Strategic guidance for businesses navigating the fintech landscape.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Service 1 */}
          <div className="bg-simios-light p-8 rounded-xl border border-gray-800 hover:border-simios-accent transition-colors duration-300">
            <div className="w-12 h-12 bg-simios-accent/20 rounded-lg flex items-center justify-center mb-6 text-simios-accent">
              <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-white mb-3">Board Advisory</h3>
            <p className="text-simios-muted">
              Providing independent, experienced oversight and strategic direction to boards. Helping steer technology roadmap and product strategy alignment.
            </p>
          </div>

          {/* Service 2 */}
          <div className="bg-simios-light p-8 rounded-xl border border-gray-800 hover:border-simios-accent transition-colors duration-300">
            <div className="w-12 h-12 bg-simios-accent/20 rounded-lg flex items-center justify-center mb-6 text-simios-accent">
              <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-white mb-3">Fintech Product Strategy</h3>
            <p className="text-simios-muted">
              Leveraging deep domain expertise from 10x Banking to help growing fintechs optimize their product market fit and operational scalability.
            </p>
          </div>

          {/* Service 3 */}
          <div className="bg-simios-light p-8 rounded-xl border border-gray-800 hover:border-simios-accent transition-colors duration-300">
            <div className="w-12 h-12 bg-simios-accent/20 rounded-lg flex items-center justify-center mb-6 text-simios-accent">
              <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4" />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-white mb-3">Technical Consulting</h3>
            <p className="text-simios-muted">
              Bridging the gap between business requirements and technical execution. Guidance on tech stack selection, AI integration, and development processes.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
